import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { loginPathForSession } from '../lib/session';

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-primary/20"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Back to the portal they came in through — the platform sign-in page would not
    // accept a tenant user's credentials at all.
    return <Navigate to={loginPathForSession({ role: user?.role })} state={{ from: location }} replace />;
  }

  // First-login rule: an account created/reset by an admin with "require password change"
  // can go nowhere until the user sets their own password.
  if (user?.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    const dashboardRoutes = {
      super_admin: '/super-admin',
      tenant_admin: '/admin',
      instructor: '/instructor',
      parent: '/diary',
      learner: '/learn'
    };
    return <Navigate to={dashboardRoutes[user?.role] || '/'} replace />;
  }

  return children;
};

export default ProtectedRoute;
